<template>
  <el-dialog
    v-dialogDrag
    :title="title + '模型场景'"
    :visible="visible"
    :close-on-click-modal="false"
    v-loading="dialogLoading"
    @close="handleClose"
    class="small-dialog"
  >
    <el-form :model="formData" label-width="160px" :rules="formRules" ref="formRef">
      <el-form-item label="模型场景路径" prop="folderId">
        <el-select
          ref="selectTree"
          v-model="formData.folderId"
          placeholder="请选择模型场景路径"
          clearable
          filterable
        >
          <el-option
            v-for="item in sceneFlatData"
            :key="item.id"
            :value="item.id"
            :label="item.name"
            class="hidden"
          ></el-option>
          <el-tree
            :data="treeData"
            :expand-on-click-node="false"
            :props="defaultTreeProps"
            node-key="id"
            highlight-current
            @node-click="handleNodeClick"
          ></el-tree>
        </el-select>
      </el-form-item>
      <el-form-item label="模型场景名称" prop="name">
        <el-input v-model="formData.name" placeholder="请输入模型场景名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="缩略图" prop="shortCutPicFileId" ref="formUpload">
        <FormUpload
          @change="fileIdChange"
          v-model="formData.shortCutPicFileId"
        ></FormUpload>
      </el-form-item>
      <el-form-item label="是否GIS场景" prop="isEnableGis">
        <el-checkbox v-model="formData.isEnableGis"></el-checkbox>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import FormUpload from './FormUpload'
import { isNil, isEmpty, cloneDeep } from 'lodash'
import { ModelSceneApi } from '@wiz-api/scene-management'

const modelSceneApi = new ModelSceneApi()

export default {
  components: {
    FormUpload,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    operateProps: {
      type: Object,
      default: () => null,
    },
    operateType: {
      type: String,
      default: 'create',
    },
    treeData: {
      type: Array,
      default: () => [],
    },
    sceneFlatData: {
      type: Array,
      default: () => []
    },
    folderId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        folderId: '',
        name: '',
        shortCutPicFileId: '',
        isEnableGis: false
      },
      formRules: {
        folderId: {required: true, message: '请选择模型场景路径', trigger: 'change'},
        name: {required: true, message: '请输入模型场景名称', trigger: 'blur'},
        isEnableGis: {required: true, message: '请选择是否GIS场景', trigger: 'blur'},
      },
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      dialogLoading: false,
      saveLoading: false
    }
  },
  async created() {
    this.dialogLoading = true
    if(!isNil(this.operateProps)) {
      this.formData = cloneDeep(this.operateProps)
    }else {
      // 新增场景默认在当前目录下
      this.formData.folderId = this.folderId
    }
    this.dialogLoading = false
  },
  computed: {
    title() {
      if (this.operateType === 'update') {
        return '编辑'
      } else {
        return '新增'
      }
    },
  },
  methods: {
    // 下拉框点击树形节点回调数据
    handleNodeClick(node) {
      this.formData.folderId = node.id
      this.$refs.selectTree.blur()
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    fileIdChange() {
      this.$refs.formUpload.$emit('el.form.change')
    },
    // 保存
    save() {
      this.$refs.formRef.validate(async valid => {
        if(valid) {
          this.saveLoading = true
          const query = cloneDeep(this.formData)
          if(isEmpty(query.shortCutPicFileId)) {
            query.shortCutPicFileId = null
          }
          const [err, res] = await modelSceneApi[this.operateType](query)
          if(!err && !isNil(res)) {
            this.$message.success({
              showClose: true,
              message: this.title + '成功！',
            })
            this.$emit('refresh')
            this.handleClose()
          }
          this.saveLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>